import { render } from "./BaseRadioGroup.vue?vue&type=template&id=3f3f8872&scoped=true"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js"

import "./BaseRadioGroup.vue?vue&type=style&index=0&id=3f3f8872&scoped=true&lang=css"

import exportComponent from "/home/k2/Documents/projects/contact-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3f8872"]])

export default __exports__